import "./MarkdownForTooltip.0.css";
import Markdown from "../../lib/builtin/components/Markdown";
const __script_base__ = {
  name: 'MarkdownForTooltip',
  components: {
    Markdown
  },
  props: {
    source: {
      type: String,
      default: ''
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.source ? _c('markdown', {
    staticClass: "uc-markdownForTooltip",
    attrs: {
      "source": _vm.source,
      "open-in-new-window": "",
      "breaks": ""
    }
  }) : _vm._e();
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/MarkdownForTooltip.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);